import { Modal } from '@inflearn/ds-modal';
import { Button, Text } from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';

type Props = {
  userName: string;
  isInstructor: boolean;
  onClosed: () => void;
  isFollowing: boolean;
  isSuccessFollowModalOpened: boolean;
};

export default function SuccessFollowModal({
  onClosed,
  userName,
  isFollowing,
  isInstructor,
  isSuccessFollowModalOpened,
}: Props) {
  const { t } = useTranslation();

  return isFollowing ? (
    <Modal.Root
      id="FollowModal"
      opened={isSuccessFollowModalOpened}
      onClose={onClosed}
      size="xs"
      closeOnClickOutside
    >
      <Modal.Overlay>
        <Modal.Content>
          <Modal.Header>
            <Modal.Title css={{ textAlign: 'center' }}>{t('팔로우 완료')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Text align="center" my={16} css={{ whiteSpace: 'pre-line' }}>
              {isInstructor
                ? t(
                    '이제부터 {{userName}}님의 새 강의, 새 블로그 글이 업데이트 되면 알림을 받을 수 있어요.',
                    { userName: userName },
                  )
                : t('이제부터 {{userName}}님의 블로그 글이 업데이트 되면 알림을 받을 수 있어요.', {
                    userName: userName,
                  })}
            </Text>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="filled"
              color="infgreen"
              size="md"
              radius="md"
              onClick={onClosed}
              fullWidth
            >
              {t('확인')}
            </Button>
          </Modal.Footer>
        </Modal.Content>
      </Modal.Overlay>
    </Modal.Root>
  ) : (
    <Modal.Root
      id="CancelFollowModal"
      opened={isSuccessFollowModalOpened}
      onClose={onClosed}
      closeOnClickOutside
      size="xs"
    >
      <Modal.Overlay>
        <Modal.Content>
          <Modal.Header>
            <Modal.Title css={{ textAlign: 'center' }}>{t('팔로우 취소')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Text align="center" my={16}>
              {t('{{userName}}님 팔로우를 취소했어요.', { userName })}
            </Text>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="filled"
              color="infgreen"
              size="md"
              radius="md"
              onClick={onClosed}
              fullWidth
            >
              {t('확인')}
            </Button>
          </Modal.Footer>
        </Modal.Content>
      </Modal.Overlay>
    </Modal.Root>
  );
}
